module.exports = __webpack_public_path__ + "static/bassman-25_800.8f4d1a03.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/bassman-25_800.jpg
// module id = 627
// module chunks = 0